import { memo, useContext } from 'react';
import { ClientStatusContext } from '../../common/client-status';

import Portal from '../portal';
import ProfileCreation from '../profile-creation';

const Auth = () => {
  const { clientStatus } = useContext(ClientStatusContext);

  switch (clientStatus) {
    case 'CLIENT_PROFILE_ACTIVE':
      return <Portal />;
    default:
      return <ProfileCreation />;
  }
};

export default memo(Auth);
